module.exports = __webpack_public_path__ + "static/img/index_logo_image.5322b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_logo_image.png
// module id = cOS8
// module chunks = 1